// extracted by mini-css-extract-plugin
export default {"outerWrapper":"PhysicalProps_outerWrapper__0glEL","innerWrapper":"PhysicalProps_innerWrapper__zVyyD"};